import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

import pages from "@/components/pages.vue";
import pageBanner from "@/components/pageBanner.vue";
import loading from "@/components/loading.vue";
import product_list from "@/components/product_list.vue";

const app = createApp(App);
app.component('Pages', pages)
app.component('PageBanner', pageBanner)
app.component('Loading', loading)
app.component('ProductList', product_list)

app.config.globalProperties.$baseURL = axios.defaults.baseURL.replace(/\/api/g, "")

app
  .use(store)
  .use(router)
  .mount("#app");
